import { render, staticRenderFns } from "./SemesterTable.vue?vue&type=template&id=2c979565&"
import script from "./SemesterTable.vue?vue&type=script&lang=js&"
export * from "./SemesterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports